// JavaScript Document
import GraphQL from './ConsultaGraphQLUsuarios';

import url from './ApiUrl.js';

function handleError(err){
	console.log(`Request failed: ${err}`);
}

const fetchUsers = (This) => {

	const options = {
		method: 'post',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL()),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {

		This.props.dispatch({
			type: 'FETCH_USERS',
			payload: {
				dataUsers: res.data.appInfo.usuarios
			}
		})

	})
	.catch(err => handleError(err));

	//termina fetch
}

export default fetchUsers;
